'use client';

import React from 'react';
import RiveProgressBar from '../RiveProgressBar';
import styles from './TopNavBar.module.scss';
import { ProgressBar } from 'types/navigation';

const ProgressBarSection: React.FC<ProgressBar> = ({
  first = 0,
  second = 0,
  third = 0,
  label = 'Getting Started',
  step = 1,
}) => {
  return (
    <div className={styles.progressBarWrap}>
      <RiveProgressBar
        first={first}
        second={second}
        third={third}
        label={label}
        step={step}
      />
    </div>
  );
};

export default ProgressBarSection;
